import { useSelector } from "react-redux";
import AddMesh from "./AddMesh";
import ViewMesh from "./ViewMesh";
import { useSplitSensorsForMeshing } from "../CustomHooks";
import { isResourceInState } from "../../redux/sensorAnalysis";
import { resources } from "../../redux/sensorAnalysisConstants";

export default function MeshViewer({ orbitRef }) {
  const { sensorsToAdding, sensorsToMoving, restOfSensors } =
    useSplitSensorsForMeshing();
  const sensoranalysisState = useSelector(
    (state) => state.sensorAnalysis.sensorAnalysisState
  );
  const isActive = isResourceInState(
    sensoranalysisState,
    resources.MANUAL_MESHING_TAB
  );
  if (!isActive) return null;

  const isAdding = isResourceInState(
    sensoranalysisState,
    resources.IS_ADDING_MESH
  );
  const isMoving = isResourceInState(
    sensoranalysisState,
    resources.IS_MOVING_MESH
  );

  return (
    <>
      {isAdding && (
        <AddMesh orbitRef={orbitRef} existingSensors={sensorsToAdding} />
      )}
      {isMoving && <ViewMesh sensors={sensorsToMoving} applyOffset />}
      <ViewMesh sensors={restOfSensors} />
    </>
  );
}
